import React, { Component } from "react";
import PropTypes from "prop-types";
import parse from "html-react-parser";

import ContentItem from "../components/content-item";

class BrowserSpecificContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userAgent: "",
    };
  }

  componentDidMount() {
    this.setState({
      userAgent: navigator.userAgent,
    });
  }

  render() {
    const { componentDetails, richText } = this.props;
    let html;
    if (typeof document !== "undefined") {
      const el = document.createElement("html");
      el.innerHTML = richText;
      const all = el.querySelectorAll("body > *");
      if (all.length) {
        html = Array.from(all);
        html.map((element, index) => {
          if (
            element.tagName.toLowerCase() === "h2" ||
            element.tagName.toLowerCase() === "h3"
          ) {
            element.id = convertToSlug(element.innerHTML);
          }
        });
      }
    }

    const uaString = this.state.userAgent.toLowerCase();

    let isChrome = /chrome/.test(uaString);
    let isExplorer = /msie/.test(uaString);
    let isExplorer_11 = /rv:11/.test(uaString);
    let isFirefox = /firefox/.test(uaString);
    let isSafari = /safari/.test(uaString);
    let isOpera = /opr/.test(uaString);
    let isEdgeDesktop = /edg/.test(uaString);
    let isEdgeiOS = /edgios/.test(uaString);
    let isEdgeAndroid = /edga/.test(uaString);
    let isSamsungBrowser = /samsungbrowser/.test(uaString);

    let isIOS = /ipad|iphone|ipod/.test(uaString);
    let isMobile = /mobile/.test(uaString);
    let isDesktop = !/mobile/.test(uaString);

    if (isChrome && isSafari) {
      isSafari = false;
    }
    if (
      isChrome &&
      (isEdgeDesktop || isEdgeiOS || isEdgeAndroid || isSamsungBrowser)
    ) {
      isChrome = false;
    }
    if (
      isSafari &&
      (isEdgeDesktop || isEdgeiOS || isEdgeAndroid || isSamsungBrowser)
    ) {
      isSafari = false;
    }
    if (isChrome && isOpera) {
      isChrome = false;
    }

    let show = true;

    componentDetails.kenticoElements.show_in_browser_s_.value.map((item) => {
      switch (item.codename) {
        case "chrome":
          show = show && isChrome;
          break;
        case "explorer":
          show = show && isExplorer;
          break;
        case "explorer_11":
          show = show && isExplorer_11;
          break;
        case "firefox":
          show = show && isFirefox;
          break;
        case "safari":
          show = show && isSafari;
          break;
        case "opera":
          show = show && isOpera;
          break;
        case "edge_desktop":
          show = show && isEdgeDesktop;
          break;
        case "edge_ios":
          show = show && isEdgeiOS;
          break;
        case "edge_android":
          show = show && isEdgeAndroid;
          break;
        case "samsung_internet":
          show = show && isSamsungBrowser;
          break;
        case "ios":
          show = show && isIOS;
          break;
        case "mobile":
          show = show && isMobile;
          break;
        case "desktop":
          show = show && isDesktop;
          break;
      }
    });

    if (show) {
      return (
        <section className="c-component">
          {html
            ? html.map((element, index) => {
                if (
                  element.tagName.toLowerCase() !== "object" &&
                  element.tagName.toLowerCase() !== "body" &&
                  element.tagName.toLowerCase() !== "head"
                ) {
                  return parse(element.outerHTML);
                } else if ("object" === element.tagName.toLowerCase()) {
                  return (
                    <ContentItem
                      key={index}
                      codename={element.getAttribute("data-codename")}
                      chapterColor={this.props.chapterColor}
                      details={componentDetails.fields.modular_content}
                      imageArray={this.props.imageArray}
                    />
                  );
                }
              })
            : ""}
        </section>
      );
    } else {
      return "";
    }
  }
}

BrowserSpecificContent.propTypes = {
  componentDetails: PropTypes.object,
  richText: PropTypes.string,
};

export default BrowserSpecificContent;
